import { observer } from 'mobx-react';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import { promocodeStore } from '~/view/screens/MarketingScreen/screens/PromocodesScreen/store/promocodeStore';
import Text from '~/view/components/Text/Text';
import React from 'react';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/types/customTooltip';

const ReoccurringUsageLimitsSwitcher = observer(() => {
  const onChangeUserUsageLimited = (value: 0 | 1) => {
    promocodeStore.changePromocode({ reoccurring_usage_limited: value ?? 0 });
  };

  return (
    <div className="d-flex flex-row mt-4 gap-20">
      <div className="d-flex flex-row align-items-center promocode-conditions__switcher-field">
        <Switcher status={promocodeStore.promocode.reoccurring_usage_limited ?? 0} onChange={onChangeUserUsageLimited} />
        <Text
          type="switcher-label"
          text="promocode_reocurring_usage_limit"
          tooltip={{
            message: 'promocode_reocurring_usage_limit_info',
            position: TOOLTIP_POSITION.FIXED,
            duration: TOOLTIP_DURATION.EXTRA_LARGE,
            iconSize: 24,
          }}
        />
      </div>
    </div>
  );
});

export default ReoccurringUsageLimitsSwitcher;
